import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation LeaveGroup($groupId: String!) {
    leaveGroup(groupId: $groupId) {
      success
      message
    }
  }
`

export interface LeaveGroupInput {
  groupId: string
}

export interface LeaveGroupOutput {
  leaveGroup: {
    success: boolean
    message: string
  }
}

export const useLeaveGroup = () => useMutation<LeaveGroupOutput, LeaveGroupInput>(mutation)
